import { ReactNode } from 'react';
import { classNames } from '@/shared/lib/classNames';
import cls from './SliderButton.module.scss';

type Props = {
    className?: string;
    icon: ReactNode;
    onClick: () => void;
};

export const SliderButton = ({ className, onClick, icon }: Props) => {
    return (
        <button className={classNames(cls.baseButton, {}, [className])} type="button" onClick={onClick}>
            {icon}
        </button>
    );
};
